{
  "pt": {
    "constants": {
      "address": {
        "city": "Cidade",
        "country": "País",
        "number": "Número",
        "street": "Rua",
        "zip": "Código postal"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "currencies": {
        "all": "Todas as moedas",
        "popular": "Populares"
      },
      "days": ["Su", "M", "Tu", "W", "O", "F", "S"],
      "languages": {
        "de": "Alemão",
        "en": "Inglês",
        "es": "Espanhol",
        "fallback_info": "Parece que isto não está disponível na sua língua. Em vez disso, estamos a utilizar a tradução existente em {fallback_locale}.",
        "fr": "Francês",
        "it": "Italiano",
        "nl": "Holandês",
        "pl": "Polaco",
        "pt": "Português"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Métrica",
        "surface": {
          "imperial": "Pés quadrados",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      "profile_statuses": {
        "active": "Ativo",
        "added": "Ainda não foi convidado",
        "blocked": "Desativado",
        "discarded": "Eliminado",
        "invited": "Convidado",
        "invited_at": "Convidado"
      },
      "profile_statuses_descriptive": {
        "active": "Última vez que esteve ativo na plataforma: {session_ended_at}",
        "added": "Ainda não foi convidado",
        "blocked": "Desativado",
        "discarded": "Eliminado",
        "invited": "Convidado mas ainda não se inscreveu",
        "invited_at": "Convidado {invited_at}. Ainda não se inscreveu"
      },
      "profile_titles": {
        "dr": "Dr",
        "mr": "Senhor",
        "mrs": "Senhora",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Dias",
        "months": "Meses",
        "weeks": "Semanas"
      },
      "time_units_count": {
        "days": "não dia | dia | dias",
        "months": "nenhum mês | mês | meses",
        "weeks": "sem semana | semana | semanas"
      },
      "timezone_regions": {
        "Africa": "África",
        "America": "América",
        "Asia": "Ásia",
        "Atlantic": "Atlântico",
        "Australia": "Austrália",
        "Europe": "Europa",
        "Pacific": "Pacífico"
      },
      "timezones": {
        "Africa/Abidjan": "África/Abidjan",
        "Africa/Cairo": "África/Cairo",
        "Africa/Casablanca": "África/Casablanca",
        "Africa/Johannesburg": "África/Joanesburgo",
        "Africa/Lagos": "África/Lagos",
        "Africa/Nairobi": "África/Nairobi",
        "America/Anchorage": "América/Anchorage",
        "America/Bogota": "América/Bogotá",
        "America/Buenos_Aires": "América/Buenos Aires",
        "America/Chicago": "América/Chicago",
        "America/Denver": "América/Denver",
        "America/Halifax": "América/Halifax",
        "America/Lima": "América/Lima",
        "America/Los_Angeles": "América/Los Angeles",
        "America/Mexico_City": "América/Cidade do México",
        "America/New_York": "América/Nova Iorque",
        "America/Phoenix": "América/Phoenix",
        "America/Santiago": "América/Santiago",
        "America/Sao_Paulo": "América/São Paulo",
        "America/St_Johns": "América/St. John's",
        "America/Toronto": "América/Toronto",
        "America/Vancouver": "América/Vancouver",
        "Asia/Bangkok": "Ásia/Banguecoque",
        "Asia/Colombo": "Ásia/Colombo",
        "Asia/Dhaka": "Ásia/Daca",
        "Asia/Dubai": "Ásia/Dubai",
        "Asia/Ho_Chi_Minh": "Ásia/Ho Chi Minh",
        "Asia/Hong_Kong": "Ásia/Hong Kong",
        "Asia/Jakarta": "Ásia/Jacarta",
        "Asia/Karachi": "Ásia/Carachi",
        "Asia/Kolkata": "Ásia/Calcutá",
        "Asia/Kuala_Lumpur": "Ásia/Kuala Lumpur",
        "Asia/Makassar": "Ásia/Makassar",
        "Asia/Manila": "Ásia/Manila",
        "Asia/Riyadh": "Ásia/Riade",
        "Asia/Seoul": "Ásia/Seul",
        "Asia/Shanghai": "Ásia/Xangai",
        "Asia/Singapore": "Ásia/Singapura",
        "Asia/Taipei": "Ásia/Taipé",
        "Asia/Tehran": "Ásia/Teerão",
        "Asia/Tokyo": "Ásia/Tóquio",
        "Atlantic/Reykjavik": "Atlântico/Reiquiavique",
        "Australia/Adelaide": "Austrália/Adelaide",
        "Australia/Brisbane": "Austrália/Brisbane",
        "Australia/Darwin": "Austrália/Darwin",
        "Australia/Hobart": "Austrália/Hobart",
        "Australia/Melbourne": "Austrália/Melbourne",
        "Australia/Perth": "Austrália/Perth",
        "Australia/Sydney": "Austrália/Sydney",
        "Europe/Amsterdam": "Europa/Amesterdão",
        "Europe/Athens": "Europa/Atenas",
        "Europe/Belgrade": "Europa/Belgrado",
        "Europe/Berlin": "Europa/Berlim",
        "Europe/Brussels": "Europa/Bruxelas",
        "Europe/Bucharest": "Europa/Bucareste",
        "Europe/Budapest": "Europa/Budapeste",
        "Europe/Copenhagen": "Europa/Copenhaga",
        "Europe/Dublin": "Europa/Dublin",
        "Europe/Helsinki": "Europa/Helsínquia",
        "Europe/Istanbul": "Europa/Istambul",
        "Europe/Lisbon": "Europa/Lisboa",
        "Europe/London": "Europa/Londres",
        "Europe/Madrid": "Europa/Madrid",
        "Europe/Moscow": "Europa/Moscovo",
        "Europe/Oslo": "Europa/Oslo",
        "Europe/Paris": "Europa/Paris",
        "Europe/Prague": "Europa/Praga",
        "Europe/Rome": "Europa/Roma",
        "Europe/Stockholm": "Europa/Estocolmo",
        "Europe/Vienna": "Europa/Viena",
        "Europe/Warsaw": "Europa/Varsóvia",
        "Europe/Zurich": "Europa/Zurique",
        "Pacific/Auckland": "Pacífico/Auckland",
        "Pacific/Fiji": "Pacífico/Fiji",
        "Pacific/Honolulu": "Pacífico/Honolulu"
      },
      "wind_orientations": {
        "east": "Leste",
        "north": "Norte",
        "northeast": "Nordeste",
        "northwest": "Noroeste",
        "select": "Selecionar orientação",
        "south": "Sul",
        "southeast": "Sudeste",
        "southwest": "Sudoeste",
        "west": "Oeste"
      }
    }
  }
}
